import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useBarimtsList() {
  // Use toast
  const toast = useToast()

  const refReportDataTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'bill_id_suffix', sortable: true, label: 'Дугаар' },
    { key: 'username', sortable: true, label: 'Утасны дугаар' },
    { key: 'lottery', sortable: true, label: 'Сугалааны дугаар' },
    { key: 'amount', sortable: true, label: 'Мөнгөн дүн' },
    { key: 'source_id', sortable: true, label: 'Эх үүсвэр' },
    { key: 'ddtd', sortable: true, label: 'ДДТД' },
    { key: 'print_ebarimt', sortable: true, label: 'Төлөв' },
    { key: 'print_date', sortable: true, label: 'Хэвлэсэн огноо' },
    { key: 'is_returned', sortable: true, label: 'Буцаагдсан эсэх' },
    { key: 'email', sortable: true, label: 'Имэйл' },
    { key: 'sent_email_date', sortable: true, label: 'Имэйл илгээсэн огноо' },
    { key: 'actions', sortable: false, label: 'Үйлдэл' }
  ]
  const perPage = ref(10)
  const totalOrganizations = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const ebarimtFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refReportDataTable.value ? refReportDataTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalOrganizations.value,
    }
  })

  const refetchData = () => {
    refReportDataTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, ebarimtFilter], () => {
    refetchData()
  })

  
  const fetchEbarimtData = (ctx, callback) => {
    const filter = ebarimtFilter.value || {}
    const payload = {
      page: currentPage.value,
      per_page: perPage.value,
    }
    if (filter.phone_number) payload.phone_number = filter.phone_number
    if (filter.date_from) payload.date_from = filter.date_from
    if (filter.date_to) payload.date_to = filter.date_to

    store
      .dispatch('app-ebarimt/fetchEbarimtData', payload)
      .then(response => {
        const { items, total } = response.data
        callback(items)
        totalOrganizations.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'И-баримт мэдээлэл татахад алдаа гарлаа',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveOrganizationRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveOrganizationRoleIcon = role => {
    if (role === 'subscriber') return 'OrganizationIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'OrganizationIcon'
  }

  const resolveOrganizationStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }


  return {
    fetchEbarimtData,
    tableColumns,
    perPage,
    currentPage,
    totalOrganizations,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refReportDataTable,

    resolveOrganizationRoleVariant,
    resolveOrganizationRoleIcon,
    resolveOrganizationStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
    ebarimtFilter
  }
}
